import { render, staticRenderFns } from "./WorkflowContainer.vue?vue&type=template&id=718da01c&scoped=true"
import script from "./WorkflowContainer.vue?vue&type=script&lang=ts"
export * from "./WorkflowContainer.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowContainer.vue?vue&type=style&index=0&id=718da01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718da01c",
  null
  
)

export default component.exports